import noop from 'lib/function/noop'

// Browser-wide state, so it is cached once per page rather than per composer.
let permissionState: PermissionState | undefined
let isWatching = false
const listeners = new Set<() => void>()

function notifyListeners() {
  listeners.forEach(listener => listener())
}

function watchPermission() {
  if (isWatching || typeof navigator === 'undefined' || !navigator.permissions) return
  isWatching = true
  navigator.permissions.query({ name: 'microphone' }).then((status) => {
    permissionState = status.state
    notifyListeners()
    status.addEventListener('change', () => {
      permissionState = status.state
      notifyListeners()
    })
  }).catch(noop)
}

export function subscribeToMicrophonePermission(onChange: () => void) {
  watchPermission()
  listeners.add(onChange)
  return () => {
    listeners.delete(onChange)
  }
}

export function isMicrophoneBlocked(): boolean {
  return permissionState === 'denied'
}
